var React = require('react');

function TriangleReasonsSales (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M713.734 461.962L484.358 25.4359M713.734 461.962L385.471 333.077M713.734 461.962L64.2739 372.436M484.358 25.4359L385.471 333.077M484.358 25.4359L64.2739 372.436M385.471 333.077L64.2739 372.436","stroke":"#E5E5E5"}));
}

TriangleReasonsSales.defaultProps = {"width":"715","height":"654","viewBox":"0 0 715 654","fill":"none"};

module.exports = TriangleReasonsSales;

TriangleReasonsSales.default = TriangleReasonsSales;
